import { store } from '../state/store';

export interface AudioOutputDeviceOption {
  deviceId: string;
  label: string;
}

function getAudioLabel(device: MediaDeviceInfo, index: number): string {
  if (device.label?.trim()) return device.label;
  return `Speaker ${index + 1}`;
}

export function supportsAudioOutputSelection(): boolean {
  if (typeof Audio === 'undefined') return false;
  return typeof (new Audio() as HTMLAudioElement & { setSinkId?: unknown }).setSinkId === 'function';
}

export async function listAudioOutputDevices(): Promise<AudioOutputDeviceOption[]> {
  if (typeof navigator === 'undefined' || !navigator.mediaDevices?.enumerateDevices) {
    return [];
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices
      .filter((device) => device.kind === 'audiooutput')
      .map((device, index) => ({
        deviceId: device.deviceId,
        label: getAudioLabel(device, index),
      }));
  } catch (err) {
    console.warn('[audio-output] Failed to enumerate audio devices:', err);
    return [];
  }
}

export async function applyAudioOutput(audio: HTMLAudioElement): Promise<void> {
  const sinkId = store.getState().drivingMode.audioOutputDeviceId;
  const setSinkId = (audio as HTMLAudioElement & { setSinkId?: (id: string) => Promise<void> }).setSinkId;

  if (!sinkId || typeof setSinkId !== 'function') return;

  try {
    await setSinkId.call(audio, sinkId);
  } catch (err) {
    console.warn('[audio-output] Failed to set sinkId:', err);
  }
}
